import { type FunctionComponent, type SVGProps } from 'react';
import { SvgIcon } from '../../icons/SvgIcon';

export type MediShareLogoIconProps = SVGProps<SVGSVGElement>;

export const MediShareLogoIcon: FunctionComponent<MediShareLogoIconProps> = (
  props,
) => {
  return (
    <SvgIcon
      fill={'var(--color-brand-green)'}
      height={96}
      viewBox="0 0 96 96"
      width={96}
      {...props}
    >
      <path d="M27.4 27.1a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13Zm0 40.7a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13Z" />
      <path d="M41.7 94.6S37.5 89 37 76.5A74.3 74.3 0 0 1 41.6 47s-7.7 3.4-17 4A28 28 0 0 1 8 47.7s3-3.7 9.8-6.6c1.8.8 4 1.6 6.6 2.2 3.4.7 9 1.3 14.3 1.3h5.7V64a75.4 75.4 0 0 0 3.3 20c-2.5 7.5-6 10.7-6 10.7Zm26.5-67.5a6.5 6.5 0 1 1 0-13 6.5 6.5 0 0 1 0 13Z" />
      <path d="M54.3 1s4.3 8 3.5 18c-.6 8.2-3.8 15.8-3.8 15.8s7.5-3.3 17-4c10-.9 16.6 3.4 16.6 3.4S84.6 38 78 41c-2-.8-4.1-1.6-6.7-2.2-3.4-.8-9-1.3-14.2-1.3h-5.8v-5.7c0-5.3-.5-11-1.2-14.3-.6-2.6-1.3-4.8-2.2-6.8C50.6 4 54.3 1 54.3 1Zm-13 0s3.7 3 6.5 9.7a49 49 0 0 0-3.4 21v5.8h-5.7c-5.3 0-11 .5-14.3 1.3a36 36 0 0 0-6.6 2.1C11 38.1 8 34.3 8 34.3s6.8-4.4 16.7-3.5c9.4.8 17 4 17 4s-3.3-7.5-3.9-15.8C37 9 41.3 1 41.3 1Zm26.9 66.8a6.5 6.5 0 1 1 0-13 6.5 6.5 0 0 1 0 13Z" />
      <path d="M53.9 94.6s4.3-5.7 4.9-18.1A74.3 74.3 0 0 0 54 47s7.7 3.4 17.1 4c9.8.7 16.5-3.5 16.5-3.5S84.7 44 78 41c-2 .8-4.1 1.6-6.7 2.2-3.4.7-9 1.3-14.2 1.3h-5.8v19.4a75.4 75.4 0 0 1-3.3 20 28 28 0 0 0 6 10.7Z" />
    </SvgIcon>
  );
};
